import { ComputedStaticTextInput } from '@framework/form';
import React from 'react';
import { ConfigFormItem } from '../../../../../../../ui/form/ConfigFormItem';
import { ComputeExpression } from '../../../../../../expressions/compute/ComputeExpression';
import { useStringExpressionValue } from '../../../../computed';

export interface IComputedStringPaymentRowFieldProps {
  name: string;
  label: string;
  help?: string;
  readonly: boolean;
  expression: ComputeExpression;
}

/**
 * Componente di renderizzazione di un campo di tipo stringa calcolato
 * per la voce dic osto
 */
export function ComputedStringPaymentRowField(
  props: IComputedStringPaymentRowFieldProps,
) {
  const { name, label, help, readonly, expression } = props;

  const value = useStringExpressionValue(name, expression);

  return (
    <ConfigFormItem name={name} label={label} help={help} readonly={readonly}>
      <ComputedStaticTextInput
        name={name}
        value={value}
        readonly={readonly}
        removeBorder
      />
    </ConfigFormItem>
  );
}
